import { Component, inject, ChangeDetectionStrategy } from '@angular/core';
import { FormGroup, FormControl, Validators, ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import {
  MatDialogActions,
  MatDialogContent,
  MatDialogRef,
  MatDialogTitle,
} from '@angular/material/dialog';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { InputField } from '../../../../shared/components/input-field/input-field';
import { SyncDnsZonesDialogResult } from '../../models/sync-dns-zones.model';

@Component({
  selector: 'app-sync-dns-zones-dialog',
  imports: [
    ReactiveFormsModule,
    MatDialogTitle,
    MatDialogContent,
    MatDialogActions,
    MatButtonModule,
    FontAwesomeModule,
    InputField,
  ],
  templateUrl: './sync-dns-zones-dialog.component.html',
  styleUrl: './sync-dns-zones-dialog.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SyncDnsZonesDialogComponent {
  private readonly dialogRef =
    inject<MatDialogRef<SyncDnsZonesDialogComponent, SyncDnsZonesDialogResult>>(MatDialogRef);

  readonly form = new FormGroup({
    step: new FormControl<number | null>(null, {
      validators: [Validators.required, Validators.min(0), Validators.pattern(/^\d+$/)],
    }),
  });

  submit(): void {
    if (this.form.invalid) {
      this.form.markAllAsTouched();
      return;
    }

    const { step } = this.form.getRawValue();

    this.dialogRef.close({ step: Number(step) });
  }

  close(): void {
    this.dialogRef.close();
  }
}
